import type { IUseCase } from 'shared-kernel';
import type { ITwoFactorRepository } from '../../../domain/ports';

export interface VerifyBackupCodeInput {
  idUtilisateur: string;
  code: string;
}

export class VerifyBackupCodeUseCase implements IUseCase<VerifyBackupCodeInput, boolean> {
  constructor(
    private readonly twoFactorRepository: ITwoFactorRepository,
  ) {}

  async execute(input: VerifyBackupCodeInput): Promise<boolean> {
    const response = await this.twoFactorRepository.verifyBackupCode(input);

    if (!response.succes || !response.data) {
      throw new Error(response.message || 'Code backup invalide');
    }

    return response.data.codeValide;
  }
}
